import type { KV, KVContent } from '@/models/interface/kv';
import type { HookState } from '@/models/interface/response';
import { api } from '@/services';
import { reactive } from 'vue';

const basicDomain = 'https://dsn.funday.asia/funday/';

function dto (p: KVContent): KV | undefined {
  p.list.map((v: any) => {
    if (v.imageDesktop) {
      v.imageDesktop = basicDomain + v.imageDesktop
    }

    if (v.imagePad) {
      v.imagePad = basicDomain + v.imagePad
    }

    if (v.imageMobile) {
      v.imageMobile = basicDomain + v.imageMobile
    }
  })
  // console.log('===', p)
  return p.list.length > 0 ? p.list[0] : undefined;
}

export function useKv() {
  const state = reactive<HookState<KV | undefined>>({
    data: undefined,
    isLoading: false,
    isSuccessful: false,
    error: undefined,
  });

  // 列表查看
  const fetchAll = async () => {
    state.isLoading = true;
    state.error = null;
    try {
      const res = await api.kv.fetchAll();

      state.data = dto(res.data.content);
    } catch (error: any) {
      state.error = error.message;
    } finally {
      state.isLoading = false;
    }
  };

  return {
    state,
    fetchAll,
  };
}
